package co.maytes.standupbot.dashboard.features.templates

import co.maytes.standupbot.dashboard.components.motion.ViewPhase

fun ListPhase.viewPhase(): ViewPhase = when (this) {
    ListPhase.Idle, ListPhase.Loading -> ViewPhase.Loading
    ListPhase.Failed -> ViewPhase.Error
    ListPhase.Ready -> ViewPhase.Ready
}
